export { default } from './Link.component';
